/**
 * Created by RSchweber-Koren on 3/23/2017.
 */

class TrackingEventEditorFlowError extends Error {
    constructor({currentFlowName, flowErrorMessage, flowErrorData}) {
        super(flowErrorMessage);
        this.name = "TrackingEventEditorFlowError";
        this.currentFlow = currentFlowName;
        this.errorData = flowErrorData;
    }
}

export default TrackingEventEditorFlowError;


//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/TrackingEventEditorFlowError.js
// module id = 1S8p
// module chunks = 1